let instance = null

/**
 * A global event bus for unrelated components that need to talk to each other.
 */
class EventBus {
  constructor() {
    if (!instance) {
      this.events = {}
      // eslint-disable-next-line @typescript-eslint/no-this-alias --- this assignment is acceptable for the singleton pattern
      instance = this
    }

    return instance
  }

  $emit(event, message) {
    if (!this.events[event]) return

    const callbacks = this.events[event]

    for (let i = 0, l = callbacks.length; i < l; i++) {
      const callback = callbacks[i]

      callback.call(this, message)
    }
  }

  $on(event, callback) {
    if (!this.events[event]) this.events[event] = []

    this.events[event].push(callback)
  }
}

export default new EventBus()
